@use 'sass:color';
@use '@lib/assets/styles/main' as *;
@use '@lib/components/Select/SelectExtends' as *;
@use '@lib/components/Typography/TypographyExtends' as *;

.mapWrapper {
  position: relative;
  &.hasError {
    .map {
      border-color: $error900;
    }
  }
  &.hasFullHeight {
    height: 100%;
    display: flex;
    flex-direction: column;
    .map {
      flex: 1 1 auto;
    }
  }
}

.map {
  position: relative;
  z-index: 1;
  &.mapSmall {
    height: 300px;
  }
  &.mapMedium {
    height: 500px;
  }
  &.mapLarge {
    height: 708px;
  }
  &.mapFull {
    min-height: 300px;
    height: 100%;
  }
  &.mapBordered {
    border-radius: 10px;
    border: 1px solid $gray200;
  }
}

// Search Autocomplete Styles
.searchContainer {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: $zIndexTooltip;
  width: 342px;
  max-width: calc(100% - 8px);
}

// Generic top-right overlay container
.topRightOverlay {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: $zIndexTooltip;
}

.suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 8px 0;
  @extend %dropDownStyle;
  @include scrollStyles;
  & > div {
    max-height: 200px;
    overflow-y: auto;
  }
}

.suggestion {
  @include dropDownItemStyle;
}

// Custom Button Styles
:global(.leaflet-bar-center),
:global(.leaflet-bar-add-marker) {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 5px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }

  &.active {
    background-color: $gray900;
    color: white;
    border-color: $gray900;
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

:global(.leaflet-bar-fullscreen) {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 5px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
    border-color: #999;
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

.colorPicker {
  position: absolute;
  z-index: 1000;
  bottom: 20px;
  right: 20px;
  background-color: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.colorOptions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.colorOption {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  &.active {
    border-color: #333;
    transform: scale(1.1);
  }
}

.applyButton {
  background-color: $success900;
  color: $gray0;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: color.adjust($success900, $lightness: -10%);
  }
}

.markerIconWrap {
  position: relative;
  width: 58px;
  height: 62px;
}

.markerImageWrap {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.markerImageWrapSmall {
  top: 9px;
}

.markerClusterCounter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
  color: $gray0;
  @include bodyStyle;
}
